import { lazyLoadView } from '@router/helpers';
export default [
  {
    path: '/i/:id(\\d+)/pengimbasan-ajuan',
    name: 'pengimbasan-ajuan',
    component: () => lazyLoadView(import('@views/instansi/pengimbasan/ajuan/List')),
    meta: {
      title: 'Kelola Peserta Pelatihan Pengimbasan',
    },
  },
  {
    path: '/i/:id(\\d+)/pengimbasan-kelas',
    name: 'pengimbasan-kelas',
    component: () => lazyLoadView(import('@views/instansi/pengimbasan/kelas/Index')),
    meta: {
      title: 'Kelola Kelas Pelatihan Pengimbasan',
    },
  },
  {
    path: '/i/:id(\\d+)/pengimbasan-kelas/:kelas_id',
    name: 'pengimbasan-kelas-detail',
    component: () => lazyLoadView(import('@views/instansi/pengimbasan/kelas/Detail')),
    meta: {
      title: 'Detail Kelas Pelatihan Pengimbasan',
    },
  },
  {
    path: '/i/:id(\\d+)/pengimbasan-kelas-nilai/:kelas_id',
    name: 'pengimbasan-kelas-nilai',
    component: () => lazyLoadView(import('@views/instansi/pengimbasan/nilai/Detail.vue')),
    meta: {
      title: 'Detail Nilai Peserta Pengimbasan',
    },
  },
  {
    path: '/i/:id(\\d+)/pengimbasan-nilai',
    name: 'pengimbasan-nilai',
    component: () => lazyLoadView(import('@views/instansi/pengimbasan/nilai/List')),
    meta: {
      title: 'Kelola Nilai Pengimbasan',
    },
  },
  {
    path: '/i/:id(\\d+)/pengimbasan-nilai/:kelas_id',
    name: 'pengimbasan-nilai-peserta',
    component: () => lazyLoadView(import('@views/instansi/pengimbasan/nilai/Detail.vue')),
    meta: {
      title: 'Kelola Nilai Pengimbasan',
    },
  },
];
